/**
 * Google Calendar appointment schedule URLs. Payment is collected on Google’s booking page when enabled.
 * Add inPerson / virtual links per service — do not embed the Google script; use direct URLs.
 */
export type ServiceBookingModalityLinks = {
  virtual?: string;
  inPerson?: string;
};

/** CMS service card id → booking URLs */
export const SERVICE_BOOKING_LINKS: Record<string, ServiceBookingModalityLinks> = {
  'postmarital-counseling': {
    virtual:
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0jfXbZFoTONqp2xO7c25VMBirVHTfT1kBX_7KZ_Phzg_m-4zolAUAMTBbpSZHoQSUObtidM2lc?gv=true',
    inPerson:
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ3WqJsc9KtStPxMRdI12rcEwAiXOmxhZAL9oDugGSGtRNP-UBJDEReilKqbEarKhwhpPlYxB5-_?gv=true', // Marriage & couples — in person
  },
  'counseling-1on1': {
    virtual:
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ00tnTPvzT4m4juPR8OMOoDHDahoyY5S3mq7_AUdu29pNCBiQlQot-7sPD5p5L6qOYunyOaV-Kw?gv=true',
    inPerson:
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0kILpVhpHlMYidNOS4Bg-P4m0SsbPF5C_tBIlQVNBz0lwB1Jxs7HbB1qoUqGkm1ig5FfvF4AXp?gv=true', // Individual — in person
  },
  'family-counseling': {
    virtual:
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1GT2bE90udmGbPPQP2ZxP9Cbwt50gVfBrY6Uy54ARdKQNRFnc_VtyZN4pV6R71b8kTMXsdnAZl?gv=true',
    inPerson:
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2p07uUCMXZ2FDqI6I9kfzrSn2lEk8bxnZ2QDxiNk3VRKM8-pbetpMIF_N51W4Lzky5kmTK_PX5?gv=true',
  },
};

export function getServiceBookingLinks(serviceId: string): ServiceBookingModalityLinks {
  return SERVICE_BOOKING_LINKS[serviceId] ?? {};
}

export function hasServiceBookingLinks(serviceId: string): boolean {
  const { virtual, inPerson } = getServiceBookingLinks(serviceId);
  return Boolean(virtual?.trim() || inPerson?.trim());
}
